<template>
  <div class="input-field">
    <label v-if="label">{{ label }}</label>

    <template v-if="preview">
      <div class="my-3 relative">
        <img
          :src="imagePreview"
          alt="Framework icon"
          class="block w-full rounded-md border"
        >
        <AppButton
          v-if="deletable"
          class="text-nowrap btn-danger absolute left-2 top-2"
          @click="$emit('delete')"
        >
          x
        </AppButton>
      </div>
    </template>

    <div class="flex items-center justify-end gap-2">
      <input
        type="file"
        :required="required"
        class="max-w-lg"
        accept="image/jpeg,image/png,image/svg+xml,image/bmp/image/webp"
        @change="handleImageChange"
      >
    </div>
  </div>
</template>

<script setup>
import { ref } from 'vue';

import { AppButton } from '@/components/buttons';

const props = defineProps({
  label: {
    type: String,
    default: null,
  },
  required: {
    type: Boolean,
    default: false,
  },
  focus: {
    type: Boolean,
    default: false,
  },
  validationError: {
    type: Object,
    default: () => null,
  },
  preview: {
    default: () => null,
  },
  deletable: {
    type: Boolean,
    default: false,
  },
});

defineEmits('delete');

const imagePreview = ref();
const file = ref(null);

const handleImageChange = e => {
  file.value = e.target.files.length ? e.target.files[0] : null;

  if (!file.value) {
    return;
  }

  // Handles updating the image preview before the form is saved
  const reader = new FileReader();

  reader.onload = event => {
    imagePreview.value = event.target.result;
  };

  reader.readAsDataURL(file.value);
};

imagePreview.value = props.preview instanceof File ? handleImageChange({ target: { files: [props.preview] } }) : props.preview;
</script>
